import { createSelector } from 'helpers/reselect'

export const getAppointments = ({ appointment }) => appointment

export const getAppointmentDate = createSelector(
  [getAppointments],
  appointment => appointment && appointment.dates
)
